import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import MuiTypography from '@mui/material/Typography';
import { RichText } from '@sitecore-jss/sitecore-jss-nextjs';

export const StBox = styled(Box)(({}) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: '1rem',
  marginTop: '1.5rem',
  marginBottom: '1.5rem',
}));

export const StTypography = styled(MuiTypography)(({ theme }) => ({
  color: theme.palette.neutral8.main,
  textAlign: 'left',
  fontSize: '32px',
  fontWeight: 500,
  lineHeight: '38px',
  marginLeft: '1rem',
  [theme.breakpoints.down('lg')]: {
    fontSize: '30px',
    lineHeight: '36px',
  },
  [theme.breakpoints.down('sm')]: {
    fontSize: '20px',
    lineHeight: '38px',
  },
}));

export const StRichText = styled(RichText)(({ theme }) => ({
  color: theme.palette.neutral8.main,
  fontSize: '24px',
  fontWeight: '400',
  lineHeight: '28px',
  [theme.breakpoints.down('lg')]: {
    fontSize: '20px',
    lineHeight: '32px',
  },
  [theme.breakpoints.down('sm')]: {
    fontSize: '16px',
    lineHeight: '32px',
  },
}));

export const StArticleRichText = styled('div')(({ theme }) => ({
  color: theme.palette.neutral8.main,
}));

export const StTitle = styled(MuiTypography)(({ theme }) => ({
  color: theme?.palette?.text.primary,
  textAlign: 'left',
  fontSize: '24px',
  fontWeight: 500,
}));

export const StArticleTitle = styled(MuiTypography)(({ theme }) => ({
  color: theme.palette.heading.main,
  textAlign: 'left',
  fontSize: '24px',
  fontWeight: 500,
  lineHeight: '24px',
  [theme.breakpoints.down('sm')]: {
    fontSize: '20px',
    lineHeight: '24px',
  },
}));

export const STPaginationButton = styled(Button)(({ theme }) => {
  return {
    color: theme.palette.primary.main,
    fontSize: '16px',
    fontWeight: '400',
    lineHeight: '20px',
    minWidth: '24px',
    marginBottom: '30px',
    '&.active': {
      background: theme.palette.primary.main,
      color: theme.palette.neutral0.main,
    },
  };
});
